import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { CUSTOMER_VERIFICATION, CUSTOMER_VERIFICATION_SUCCESS, CUSTOMER_VERIFICATION_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* customerVerification({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { clientId, programId, userId } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/clients/${clientId}/programs/${programId}/users/${userId}/verify`,
      method: 'POST',
      data: payload?.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: CUSTOMER_VERIFICATION_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: CUSTOMER_VERIFICATION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CUSTOMER_VERIFICATION_ERROR, payload: error });
  }
}

export function* watchcustomerVerification() {
  yield takeEvery(CUSTOMER_VERIFICATION, customerVerification);
}

function* customerVerificationSaga() {
  yield all([fork(watchcustomerVerification)]);
}

export default customerVerificationSaga;
